import React from 'react';

/**
 * <Card title="Recent activity" action={<button>Refresh</button>}>...</Card>
 */
const Card = ({ title, subtitle, action, children, className = '', padding = true, footer }) => (
    <div className={`card ${className}`}>
        {(title || action) && (
            <div className="px-5 py-4 border-b border-neutral-200/70 flex items-center justify-between gap-3">
                <div>
                    {title && <h3 className="text-sm font-semibold text-neutral-900">{title}</h3>}
                    {subtitle && <p className="text-xs text-neutral-500 mt-0.5">{subtitle}</p>}
                </div>
                {action}
            </div>
        )}
        <div className={padding ? 'p-5' : ''}>
            {children}
        </div>
        {footer && (
            <div className="px-5 py-3 border-t border-neutral-200/70 bg-neutral-50/60 rounded-b-xl">
                {footer}
            </div>
        )}
    </div>
);

export default Card;
